@if (!hideNavigation) {
<div id="commonHeaderDiv">
  <!-- Common Header Navbar -->
  <nav class="navbar navbar-default hidden-print tw-flex" role="navigation">
    <div class="tw-flex tw-justify-between tw-items-center tw-flex-grow">
      <div class="tw-flex tw-gap-2 tw-px-2 tw-items-center">
        <button
          mat-icon-button
          tabindex="0"
          class="navbar-brand text-center tw-cursor-pointer"
          [class.lg:!tw-hidden]="!isScreenShareApp"
          id="mobileMenuButton"
          (click)="openMobileMenu.emit()"
          aria-label="Open menu"
        >
          <mat-icon svgIcon="menu" class="large medium"></mat-icon>
        </button>

        <div [class.lg:!tw-ml-8]="!isScreenShareApp">
          <page-title></page-title>
        </div>
      </div>

      <div class="tw-flex tw-items-center">
        <!-- Nav Links -->
        <div class="nav navbar-nav actions-nav lg:tw-gap-1">
          <!-- Environment -->
          @if (ENV_NAME) {
          <div class="env-name-nav-item">
            <span class="env-name-label">{{ ENV_NAME }}</span>
          </div>
          } @if (!isScreenShareApp) {
          <!-- Help Widget -->
          <help-widget-button></help-widget-button>

          <!-- Appcues Launchpad -->
          <div id="appcues-launchpad"></div>
          }

          <!-- Auth -->
          <auth-buttons></auth-buttons>
        </div>
      </div>

      <!-- END Nav Links -->
    </div>
  </nav>
</div>
} @if (!cookieEnabled) {
<div class="bg-warning text-center u_padding-sm">
  <small
    ><strong>Cookies Are Disabled.</strong> Rise Vision needs to use cookies to
    properly function. Please enable cookies in your web browser and refresh
    this page.</small
  >
</div>
}
